import styled from "@emotion/styled";

const StyledDatePicker = styled.div`
  margin-bottom: 24px;
`;

export { StyledDatePicker };
